import { useBeneficiaryOverviewData } from "@/hooks/useBeneficiaryOverviewData";
import { BeneficiaryPerformanceType } from "../../types/beneficiaries";

const AccountOverview: React.FC<{
  beneficiaryData: BeneficiaryPerformanceType;
}> = ({ beneficiaryData }) => {
  const data = useBeneficiaryOverviewData(beneficiaryData);

  return (
    <>
      <table className="w-full text-left">
        <tbody>
          <tr className="border-b">
            <td className="py-4">Beginning balance</td>
            <td className="py-4 text-right">$ {data.beginningBalance}</td>
          </tr>
          <tr className="border-b">
            <td className="py-4">Your contributions</td>
            <td className="py-4 text-right">
              + $ {Math.trunc(Number(data.employeeContributions))}
            </td>
          </tr>
          <tr className="border-b">
            <td className="py-4">Employer matching</td>
            <td className="py-4 text-right">
              + $ {Math.trunc(Number(data.employerContributions))}
            </td>
          </tr>
          {/* <tr className="border-b">
            <td className="py-4">Gifts received</td>
            <td className="py-4 text-right">
              + $ {Math.trunc(Number(data.giftContributions))}
            </td>
          </tr> */}
          {/** Add this after refactor */}
          {/* <tr className="border-b">
            <td className="py-4">Investment gain</td>
            <td className="py-4 text-right">$ 0</td>
          </tr> */}
          <tr>
            <td className="py-4 font-semibold">Ending balance</td>
            <td className="py-4 text-right font-semibold">
              $ {Math.trunc(Number(data.endingBalance!))}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default AccountOverview;
